<template>
      <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                  <div class="nav-bar box-horizontal mb-0">
                <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                    <div class="flex-1">
                      <h3 class="m-0">Karyawan</h3>
                      <p class="mb-0">Daftar karyawan disini ya gan :)</p>
                    </div>
                  </div>
                  <div class="mt-3" v-show="false">
                    <button class="btn btn-primary" >Tambah Karyawan</button>
                  </div>
                  <div class="card mt-3">
                    <div class="card-body">

                        <div class="table-responsive">
                        <table class="table">
                            <thead class=" text-info">
                            <th width="50px">No</th>
                            <th>Nama Karyawan</th>
                            <th>Shift</th>
                            <th>Gaji</th>
                            <th>Bon</th>
                            <th>Tambahan</th>
                            <th>Potongan</th>
                            <th>Sisa Gaji</th>
                            <th>Aksi</th>
                            
                            </thead>
                            <!-- LOADING -->
                            <tbody v-show="data.loading">
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            </tbody>
                            <!-- DATA -->
                            <tbody v-show="!data.loading">
                            <!-- TOTAL -->
                            <tr v-if="theGet.data.List != null">
                                <td></td>
                                <td><strong>TOTAL</strong></td>
                                <td></td>
                                <td><strong>{{ myGlobal.ribu(theGet.data.Total) }}</strong></td>
                                <td><strong>{{ myGlobal.ribu(theGet.data.TotalBon) }}</strong></td>
                                <td><strong>{{ myGlobal.ribu(theGet.data.TotalTambahan) }}</strong></td>
                                <td><strong>{{ myGlobal.ribu(theGet.data.TotalPotongan) }}</strong></td>
                                <td><strong>{{ myGlobal.ribu(theGet.data.TotalSisaGaji) }}</strong></td>
                            </tr>
                            <tr v-for="(u, index) in theGet.data.List">
                                <td>
                                  {{index+1}}
                                </td>
                                <td>
                                  {{ u.knama }}
                                  <small class="d-block">Jabatan : {{ u.jabatan }}</small>
                                </td>
                                <td>
                                  {{ u.snama }}
                                </td>
                                <td>
                                  {{ myGlobal.ribu(u.gaji_pokok) }}
                                </td>
                                <td class="text-danger">
                                  {{ myGlobal.ribu(u.bon) }}
                                </td>
                                <td>
                                  <span v-if="u.tambahan != null">{{ myGlobal.ribu(u.tambahan) }} </span>
                                  <span v-else>-</span>
                                  <span class="text-info pointer"  v-if="u.tambahan == null"><i class="material-icons" @click="theGet.rangkuman(u,index,'list')">refresh</i></span>
                                  <span class="btn btn-sm btn-primary"  @click="theGet.tambah(u,index,'tambahan')" v-else><i class="material-icons">add</i></span>
                                </td>
                                <td>
                                  <span v-if="u.potongan != null">{{ myGlobal.ribu(u.potongan) }} </span>
                                  <span v-else>-</span>
                                  <span class="text-info pointer"  v-if="u.potongan == null"><i class="material-icons" @click="theGet.rangkuman(u,index,'list')">refresh</i></span>
                                  <span class="btn btn-sm btn-warning" @click="theGet.tambah(u,index,'potongan')"  v-else><i class="material-icons">add</i></span>
                                </td>
                                <td>
                                  {{ myGlobal.ribu(u.sisa_gaji) }}</br>
                                  <span v-show="u.tgl_gaji != null">Last Gajian : {{ myGlobal.tglIndo(u.tgl_gaji) }}</span>
                                </td>
                                <td>
                                  <router-link :to="{ name: 'absensi-karyawan-detail', params: { id:u.id,data:u }}" class="btn btn-sm btn-info" ><i class="material-icons">remove_red_eye</i></router-link>
                                  <button class="btn btn-sm btn-success" @click="theGet.rangkuman(u,index,'detail')" ><i class="material-icons">info</i></button>
                                </td>
                            </tr>
                            <!-- NULL -->
                            <tr v-if="theGet.data.List == null">
                                <td></td>
                                <td>Tidak ada Data </td>
                            </tr>
                            </tbody>
                        </table>

                        </div>
                    </div>
                    <div class="card-footer " v-if="theGet.data.List != null">
                      <div class="text-center" style="width:100%">
                        <button class="btn btn-info" @click="theGet.loadMore()" v-show="data.pageStat != 999">Load More...</button>
                      </div>
                    </div>
                  </div>
                </div>
                
            </div>
        </div>

        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="data.modalCekSingkron">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-body" style="max-height: 500px; overflow: auto">
                    <div v-show="data.loadingBox" class="text-center">
                      <h3 class="mb-0 text-info">Tunggu Sebentar...</h3>
                      <span>Sedang mencari data anda</span>
                    </div>
                    <div v-show="data.baru">
                      <h3 class="mb-0">Oops, tidak ada data</h3>
                      <span>Sepertinya Anda baru pertama kesini, buat akun untuk bisa menggunakan Akun ini </span>
                    </div>
                    <div v-show="!data.loadingBox" class="text-center">
                      <span>Akun Beatcom Network Anda :</span>
                      <h3 class="text-center text-info mt-1">{{data.namaQ}}</h3>
                      <button class="btn btn-info" @click="theGet.loginSubmit()">Gunakan akun ini</button>
                      <button class="btn btn-gray" @click="$router.go(-1)">Batalkan</button>
                    </div>
                  </div>
              </div>
          </div>
          
        </div>
        
        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="data.modalRangkuman">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document" >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Rangkuman Karyawan</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalRangkuman = false,data.gajianBox = false; data.cetakGajianBox = false">
                    <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="max-height: 500px; overflow: auto"  v-if="data.dRang != null">
                    
                    <div class="table-responsive" v-show="!data.cetakGajianBox">
                      <table class="table">
                        <tr>
                          <td>Nama</td>
                          <td>: {{data.dRang.knama}}</td>
                        </tr>
                        <tr>
                          <td>Telepon</td>
                          <td>: {{data.dRang.hp}}</td>
                        </tr>
                        <tr>
                          <td>Jabatan</td>
                          <td>: {{data.dRang.jabatan}}</td>
                        </tr>
                        <tr v-show="data.dRangDetail == null">
                          <td class="text-info text-center" colspan="2">Sedang mengambil data...</td>
                        </tr>

                        <tr>
                          <td>Hari Kerja</td>
                          <td>: {{data.dRangDetail.hari}} hari</td>
                        </tr>
                        <tr>
                          <td><strong>Pendapatan</strong></td>
                        </tr>
                        <tr>
                          <td>Gaji Pokok</td>
                          <td>: {{myGlobal.ribu(data.dRang.gaji_pokok)}}</td>
                        </tr>
                        <tr>
                          <td>Tambahan</td>
                          <td>: {{myGlobal.ribu(data.dRangDetail.lembur)}}</td>
                        </tr>
                        <tr>
                          <td><strong>Total Pendapatan</strong></td>
                          <td>: {{myGlobal.ribu(data.dRangDetail.totalpendapatan)}}</td>
                        </tr>
                        <tr>
                          <td><strong>Potongan</strong></td>
                        </tr>
                        <tr>
                          <td>BON</td>
                          <td>: {{myGlobal.ribu(data.dRangDetail.bon)}}</td>
                        </tr>
                        <tr>
                          <td>Potongan</td>
                          <td>: {{myGlobal.ribu(data.dRangDetail.potonganlain)}}</td>
                        </tr>
                        <tr>
                          <td><strong>Total Potongan</strong></td>
                          <td>: {{myGlobal.ribu(data.dRangDetail.totalpotongan)}}</td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                          <td><strong>PENDAPATAN BERSIH</strong></td>
                          <td>: {{myGlobal.ribu(data.dRangDetail.pendapatanbersih)}}</td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                          <td><strong>Gaji</strong></td>
                        </tr>
                        <tr>
                          <td>Belum Dibayar</td>
                          <td class="text-warning">: {{myGlobal.ribu(data.dRangDetail.sisa_gaji)}}</td>
                        </tr>
                        <tr>
                          <td>Sudah Dibayar</td>
                          <td class="text-success">: {{myGlobal.ribu(data.dRangDetail.gaji)}}</td>
                        </tr>

                        <tr>
                          <button class="btn btn-info" @click="data.gajianBox = true" v-show="!data.gajianBox">Bayar Gajian</button>
                        </tr>

                        <tr v-show="data.gajianBox" style="background-color: #e9f4ff;">
                          <td colspan="2">
                            <p class="mb-0 mt-2">Gajian</p>
                            <h3 class="m-0 f-17 text-info">{{myGlobal.ribu(data.dRangDetail.sisa_gaji)}}</h3>
                            <p class="m-0 text-secondary">Anda bisa mengetikkan sebagian atau semua gaji</p>
                            <div class="box-horizontal m-0">
                              <div class="flex-1">
                                <input type="number" class="form-control" placeholder="Ketikan Gaji..." v-model="data.gajianInput"/>
                              </div>
                              <div>
                                <button class="btn btn-primary" @click="data.gajianInput = data.dRangDetail.sisa_gaji">Semuanya</button>
                              </div>
                            </div>
                            <small class="text-danger mb-2 d-block" v-show="data.gajianInfo != null">{{data.gajianInfo}}</small>
                            
                            <button class="btn btn-info" @click="theGet.simpanGaji">Simpan Gaji</button>
                            
                          </td>
                        </tr>


                      </table>
                    </div>

                    <div class="printbox text-center" v-show="data.cetakGajianBox">
                      <p>Gaji telah tersimpan</p>
                      <button class="btn btn-success" @click="theGet.printServis()">Cetak Slip Gaji</button>
                    </div>

                  </div>
              </div>
          </div>
          
        </div>

        <!-- MODAL TAMBAHAN -->
        <div class="modal" tabindex="-1" role="dialog" v-show="data.modalTambahan">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document"  style="max-width: 800px;">
                <div class="modal-content" style="width: 800px;">
                  <div class="modal-header">
                    <h5 class="modal-title">{{data.modalTitle}} <button class="btn btn-sm btn-primary" @click="data.modalTambahBox = true"><i class="material-icons">add</i></button></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalTambahan = false">
                    <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="height: 500px; overflow: auto"  v-if="data.dRang != null">
                    <div v-show="data.modalTambahBox" class="mb-3" style="padding: 10px;background-color: #e9f4ff;border-radius: 10px;">
                      <span>Tambahkan</span>
                      <div class="form-group">
                          <label class="bmd-label-floating">Keterangan</label>
                          <input type="text" class="form-control" placeholder="Keterangan..." v-model="data.SimpanKeterangan">
                      </div>
                      <div class="form-group">
                          <label class="bmd-label-floating">Jumlah</label>
                          <input type="number" class="form-control" placeholder="Jumlah..." v-model="data.SimpanJumlah">
                      </div>
                      <span v-show="data.SimpanStatus == null">
                        <button class="btn btn-sm btn-info" @click="theGet.simpanKeuangan()">Simpan</button>
                        <button class="btn btn-sm btn-secondary" @click="data.modalTambahBox = false">Batal</button>
                      </span>
                      <span v-show="data.SimpanStatus != null">
                        <span class="text-info">Data Tersimpan. Refresh gan :) <button class="btn btn-sm btn-info" @click="theGet.refresh()">Refresh</button></span>
                      </span>
                    </div>
                    <div>
                      <span>History</span>
                        <div class="table-responsive">
                          <table class="table">
                              <thead class=" text-info">
                              <th width="40px">No.</th>
                              <th>Keterangan</th>
                              <th>Jumlah</th>
                              <th>Oleh</th>
                              </thead>
                              <tbody>
                                <tr v-for="(u, index) in data.ListTambahan">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ u.keterangan }}</td>
                                    <td>{{ myGlobal.ribu(u.uang) }}</td>
                                    <td>
                                      {{ u.oleh }}<br>
                                      <small>{{ myGlobal.tglIndo(u.tanggal) }} - {{ myGlobal.jamIndo(u.jam) }}</small>
                                    </td>
                                </tr>
                                <!-- NULL -->
                                <tr v-if="data.ListTambahan == null">
                                    <td></td>
                                    <td>Tidak ada Data </td>
                                </tr>
                              </tbody>
                          </table>
                        </div>
                    </div>
                  </div>
              </div>
          </div>
          
        </div>
        
        <div id="nota" ref="nota" v-show="false" style="width:80mm">
          <div class="header-content" style="width:100%;margin-top:10px;float:left;">
            <div style="width:100%;float:left">
              <div class="header-box" style="margin-left:1.5%;margin-right:1.5%;float:left;">
                <p style="font-size: 14pt;font-family:arial;">{{data.namaQ}}</p>
                
                <p class="title-n" style="font-size: 12pt; font-family:arial;">SLIP GAJI</p>
              </div>
            </div>
            <div style="width:100%;">
              <div class="header-box" style="width:100%;margin-left:1.5%;margin-right:1.5%;">
                <p style="margin:0;font-size: 10pt;font-family:arial;">Bulan : {{myGlobal.BulanOnly(data.bulanKaryawan)}}</p>
              </div>
            </div>
          </div>
          <div class="header-content" style="width:100%;float:left;border-bottom: 1px dotted #333;border-top: 1px dotted #333;padding-top: 10px;padding-bottom: 10px;">
            <div class="header-box" style="width:100%;margin-left:1.5%;margin-right:1.5%;" v-if="data.dRang != null">
              <p style="font-size: 10pt;font-family:arial;margin:0;">Nama : {{data.dRang.knama}} </p>
              <p style="font-size: 10pt;font-family:arial;margin:0">Telepon : {{data.dRang.hp}} </p>
              <p style="font-size: 10pt;font-family:arial;margin:0">Jabatan : {{data.dRang.jabatan}} </p>
              <p style="font-size: 10pt;font-family:arial;margin:0;margin-top:10px">Pendapatan</p>
              <p style="font-size: 10pt;font-family:arial;margin:0">Gaji Pokok : {{myGlobal.ribu(data.dRang.gaji_pokok)}} </p>
              <p style="font-size: 10pt;font-family:arial;margin:0">Tambahan : {{myGlobal.ribu(data.dRangDetail.lembur)}} </p>
              <p style="font-size: 10pt;font-family:arial;margin:0">Total Pendapatan : {{myGlobal.ribu(data.dRangDetail.totalpendapatan)}} </p>
              <p style="font-size: 10pt;font-family:arial;margin:0;margin-top:10px">Potongan</p>
              <p style="font-size: 10pt;font-family:arial;margin:0">BON : {{myGlobal.ribu(data.dRangDetail.bon)}} </p>
              <p style="font-size: 10pt;font-family:arial;margin:0">Potongan : {{myGlobal.ribu(data.dRangDetail.potonganlain)}} </p>
              <p style="font-size: 10pt;font-family:arial;margin:0">Total Potongan : {{myGlobal.ribu(data.dRangDetail.totalpotongan)}} </p>
              <p style="font-size: 10pt;font-family:arial;margin:0;margin-top:10px">Total Bersih : {{myGlobal.ribu(data.dRangDetail.pendapatanbersih)}} </p>
              <p style="font-size: 10pt;font-family:arial;margin:0">Sudah Dibayar : {{myGlobal.ribu(data.LastInputGaji)}} </p>
              <p style="font-size: 10pt;font-family:arial;margin:0">Belum Dibayar : {{myGlobal.ribu(data.LastSisaGaji)}} </p>
            </div>
          </div>
        </div>

      </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/InterfaceAbsensi' 
import Loading from '@/globalFunc/Loading' 
import vuejsDatepicker from 'vuejs-datepicker'

export default {
  name: 'Beranda',
	components: { 
    vuejsDatepicker,
    "Loading" : Loading
	}, 
  setup() {
    const data = reactive({
      loading: true,
      tanggalBox: false,
      tanggal: null,
      sampai: null,
      karyawanBox: false,
      karyawanNama: null,
      karyawanID: null,

      bulanKaryawan: null,

      // ABSENSI MODAL
      modalCekSingkron: true,
      loadingBox: true,
      baru: false,

      // RANGKUMAN 
      modalRangkuman: false,
      dRang: null,
      dRangDetail: null,

      // popup tambahan potongan
      modalTambahan: false,
      modalTitle: null,
      modalTambahBox: false,
      ListTambahan: false,

      SimpanIDKaryawan: null,
      SimpanState: null,
      SimpanKeterangan: null,
      SimpanJumlah: null,
      SimpanStatus: null,

      gajianBox: false,
      gajianInput: null,
      gajianInfo: null,

      cetakGajianBox: false,

      LastSisaGaji: 0,
      LastInputGaji: 0,
      dis: null,

      // PAGER
      page: 0,
      pageStat: 0,

      namaQ: null

    })

    const theGet = {
      customFormatter(date) {
        return moment(date).format('YYYY-MM-DD');
      },
      data: reactive({
        List: [],
        Total: "0",
        TotalBon: "0",
        TotalSisaGaji: "0",
        TotalTambahan: "0",
        TotalPotongan: "0",
        PendapatanBersih: "0",
      }),

      simpanGaji() {

        let gajiInput = data.gajianInput;
        if(gajiInput == "") {
          return false;
        }

        let gajiInputVal = parseInt(gajiInput);
        let sisaGaji = parseInt(data.dRangDetail.sisa_gaji);

        if(gajiInputVal > sisaGaji) {
          data.gajianInfo = "Gajian kelebihan dari GAJI BELUM DIBAYAR";
          //alert("fakk");
          return false;
        }

        let lastGaji = data.dRangDetail.pendapatanbersih;
        
        if(data.dRangDetail.sisa_gaji != null) {
          lastGaji = data.dRangDetail.sisa_gaji
        }

        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi'),
          karid: data.SimpanIDKaryawan,
          bulan: data.bulanKaryawan,
          dibayar: gajiInput,
          gaji: lastGaji
        };
    
        var apiUrl = inter.simpanGaji();
        myGlobal.callAbsensi(datax,apiUrl).then(x => {

          //console.log(JSON.stringify(x))

          if (x.status == true) {
            
            // data.ListTambahan = x.data;
            //data.SimpanStatus = "sukses";

            data.LastSisaGaji = parseInt(lastGaji) - parseInt(gajiInput);
            data.LastInputGaji = parseInt(data.dRangDetail.pendapatanbersih) - parseInt(data.LastSisaGaji);

            data.cetakGajianBox = true;
            

          
          } else {

            // theGet.data.List = null;

          }
        })

      },

      refresh() {
        
        theGet.datae();
        data.modalTambahan = false;
        data.SimpanIDKaryawan = null;
        data.SimpanJumlah = null;
        data.SimpanKeterangan = null;
        data.SimpanState = null;
            
      },
      simpanKeuangan() {

        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi'),
          karid: data.SimpanIDKaryawan,
          jumlah: data.SimpanJumlah,
          keterangan: data.SimpanKeterangan,
          tipe: data.SimpanState
        };
    
        var apiUrl = inter.SimpanKeuangan();
        myGlobal.callAbsensi(datax,apiUrl).then(x => {

          //console.log(JSON.stringify(x))

          if (x.status == true) {
            
            // data.ListTambahan = x.data;
            data.SimpanStatus = "sukses";
            
          
          } else {

            // theGet.data.List = null;

          }
        })
      },

      
      printServis() {
        // Pass the element id here

        this.modalBayar = false;
        this.doneBayar = false;

        let divToPrint = data.dis.$refs.nota.innerHTML;

        var newWin=window.open('','Print-Window');

        newWin.document.open();

        newWin.document.write('<html><style>@page {size: 75mm auto;margin: 0mm 0mm 0mm 0mm;}</style><body style="width:75mm;">'+divToPrint+'</body></html>');

        newWin.print();

        newWin.document.close();

        setTimeout(function(){newWin.close();},10);

        // location.href="#/penjualan/"
      },

      tambah(d,index,buat) {
        data.modalTambahan = true;
        data.modalTambahBox = false;
        
        data.modalTitle = "Tambahan Karyawan";

        
        let tipe = 'masuk';

        if(buat == 'potongan') {
          data.modalTitle = "Potongan Karyawan";
          tipe = 'keluar';
        }

        
        data.SimpanIDKaryawan = d.id;
        data.SimpanState = tipe;

        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi'),
          karid: d.id,
          tipe: tipe,
          page: "all",
          bulan: data.bulanKaryawan,
          rangkuman: "ya"
        };
    
        var apiUrl = inter.keuangan();
        myGlobal.callAbsensi(datax,apiUrl).then(x => {

          //console.log(JSON.stringify(x))

          if (x.status == true) {
            
            data.ListTambahan = x.data;
          
          } else {

            // theGet.data.List = null;

          }
        })
      },
      rangkuman(d,index,buat) {

        // alert(index);
        data.dRang = d;

        data.SimpanIDKaryawan = d.id;
        //console.log(JSON.stringify(d));

        if(buat == "detail") {
          data.modalRangkuman = true;
        }
        
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi'),
          bulan: data.bulanKaryawan,
          karid: d.id
        };
    
        var apiUrl = inter.rangkumanDetail();
        myGlobal.callAbsensi(datax,apiUrl).then(x => {

          // console.log(JSON.stringify(x))
 
          if (x.status == true) {
            var da = x.data;

            data.dRangDetail = x.data;
            
            theGet.data.List[index]["tambahan"] = da.lembur;
            theGet.data.List[index]["potongan"] = da.potonganlain;
            theGet.data.List[index]["sisa_gaji"] = da.sisa_gaji;
            theGet.data.List[index]["tgl_gaji"] = da.tgl_gaji_full;

            if(da.lembur == null) {
              theGet.data.List[index]["tambahan"] = "0";
            }
            if(da.potonganlain == null) {
              theGet.data.List[index]["potongan"] = "0";
            }
            if(da.sisa_gaji == null) {
              theGet.data.List[index]["sisa_gaji"] = "0";
            }
            
            let TotalSisaGaji = 0;
            let TotalTambahan = 0;
            let TotalPotongan = 0;

            let d = theGet.data.List;
            for (let i = 0; i < d.length; i++) {

              let sisaGaji = 0;
              if(d[i]["sisa_gaji"] != null) {
                sisaGaji = d[i]["sisa_gaji"];
              }
              TotalSisaGaji = TotalSisaGaji + parseInt(sisaGaji);

              let tambahan = 0;
              if(d[i]["tambahan"] != null) {
                tambahan = d[i]["tambahan"];
              }
              TotalTambahan = TotalTambahan + parseInt(tambahan);

              let potongan = 0;
              if(d[i]["potongan"] != null) {
                potongan = d[i]["potongan"];
              }
              TotalPotongan = TotalPotongan + parseInt(potongan);

              //console.log(d[i]["sisa_gaji"]);
            } 

            theGet.data.TotalSisaGaji = TotalSisaGaji;
            theGet.data.TotalTambahan = TotalTambahan;
            theGet.data.TotalPotongan = TotalPotongan;
          
          } else {

            // theGet.data.List = null;

          }
        })
      },
      datae() {
        data.loading = true;
        setTimeout(function() {
          theGet.getKaryawan();
        }, 1000);
      },
      login() {
        data.loading = true;
        setTimeout(function() {
          theGet.loginNow();
        }, 1000);
      },
      loginNow() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        };
    
        var apiUrl = inter.login();
        myGlobal.callAbsensi(datax,apiUrl).then(x => {
          
            // myGlobal.loger(x);


            if (!x.status == true) {
              data.baru = true;
              
            } else {
              theGet.data.List = null;
            }
            
            data.loadingBox = false;

            // data.loading = false;

            /*

            */
        })
      },
      loginSubmit() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          nama: sessionStorage.getItem('admin')
        };
    
        var apiUrl = inter.loginSubmit();
        myGlobal.callAbsensi(datax,apiUrl).then(x => {
            //myGlobal.loger(x);

            if (x.status == true) {
              //data.baru = true;
              sessionStorage.setItem('myTokenAbsensi', x.data);

              data.modalCekSingkron = false;

              theGet.datae();
              
            } else {
              //theGet.data.List = null;
              alert(x.pesan)
            }
            
        })
      },

      loadMore() {
        data.page = data.page + 1;
        
        this.getKaryawan();
      },

      getKaryawan() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myTokenAbsensi'),
          pager: data.page
        };
    
        var apiUrl = inter.karyawanList();
        myGlobal.callAbsensi(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x))

          data.loading = false;

          if (x.status == true) {
            let d = null;
            if( this.data.page == 0 ) {

              this.data.List = x.data;
              d = x.data;

            } else {
          
              let data = x.data;

              var i;
              for (i = 0; i < data.length; i++) {

                this.data.List.push(data[i]);

              }

              d = this.data.List;

            }

            let totale = 0;
            let totaleBon = 0;

            for (let i = 0; i < d.length; i++) {
              totale = totale + parseInt(d[i]["gaji_pokok"]);
              
              let bon = 0;
              if(d[i]["bon"] != null) {
                bon = d[i]["bon"];
              }
              totaleBon = totaleBon + parseInt(bon);
              //console.log(d[i]["gaji_pokok"]);
              
            } 

            this.data.Total = totale;
            this.data.TotalBon = totaleBon;
          
          } else {
            if(this.data.page == 0 ) {
              theGet.data.List = null;
            } else {
              data.pageStat = 999;
            }
          }
        })
      },
      pilihKaryawan(id,nama) {
        data.karyawanID = id,data.karyawanNama = nama;
      }
    }
    return {
      data,
      myGlobal,
      theGet
    }
  },
  mounted () {
    document.title = "Karyawan";

    this.data.dis = this;

    this.data.namaQ = sessionStorage.getItem('admin');

    this.data.bulanKaryawan = myGlobal.getTahunNow() + "-" + myGlobal.getBulan();

    let TokenAbsensi = sessionStorage.getItem("myTokenAbsensi");
    if(TokenAbsensi == null) {
      this.theGet.login();
    } else {
      this.data.modalCekSingkron = false;
      this.theGet.datae();
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.cursor-pointer{
  cursor: pointer;
}
.modal {
	display: inherit;
}
.overlay {
	position:fixed;
	top:0;bottom:0;right:0;left:0;
	background-color: rgba(0,0,0,0.5);
}

.modal td {
  border-color: #fff !important;
  padding: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/absensi/karyawan/main.vue